<div class="package-grid">
  <div class="package-grid-header bold">AUDIT PACKAGE </div>
  <div *ngIf="!auditPackageGridData" class="text">Choose a Project, Measure and Numerator above to begin.</div>

  <app-basic-grid [configuration]="auditPackageGridConfiguration"
                  [data]="auditPackageGridData"
                  [refresh]="refreshGrid"
                  [(selection)]="auditPackageGridSelection">

    <ng-template #actionItem let-rowData>
      <div class="delete-btn" title="Remove">
        <app-button text="x"
                    (onClick)="deletePackageItem(rowData)">
        </app-button>
      </div>
    </ng-template>

  </app-basic-grid>

  <app-button class="header-button"
              text="CREATE PACKAGE"
              (onClick)="promptForFileName()"
              [disabled]="!auditPackageDataAvailable">
  </app-button>

  <app-modal [(visible)]="isFileNameEntryVisible" class="audit-package-generate-modal">
    <label>Enter Audit Package Description</label>
    <div>
      <!-- TODO: Refactor using dynamic iputs -->
      <input type="text" pInputText [(ngModel)]="filename" />
    </div>
    <footer>
      <app-button class="header-button" text="GENERATE PACKAGE" (onClick)="createPackage()" [disabled]="!fileNameAvailable"></app-button>
    </footer>
  </app-modal>

  <app-modal class="audit-package-generate-modal"
             [(visible)]="showNotificationForAuditGeneration"
             rejectText="CONTINUE">
    {{complianceChangeStatus}}
  </app-modal>

</div>
